export default (second) => {
  if (second === 0) {
    return '00:00';
  }
  const m = String(Math.floor((second / 60) % 60)).padStart(2, 0);
  const s = String(Math.floor(second % 60)).padStart(2, 0);
  return `${m}:${s}`;
};
